<template>
  <svg :width="20 * scale" :height="30 * scale" viewBox="0 0 20 30">
    <polygon
      points="0,5 4,5 10,13 16,5 20,5 12,15 20,25 16,25 10,17 4,25 0,25 8,15"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    scale: { type: Number, default: 1 },
  },
});
</script>
